export default function WhiteCursor() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 46 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 3.34326L12.5825 48.6564L21.647 29.418L42.7827 27.0591L3 3.34326Z" fill="white" stroke="black" stroke-width="5.30401" stroke-linejoin="round" />
        </svg>
    )
}